import React, { useRef, useState } from 'react';
import TuuiNavBar from '../navbar/TuuiNavBar.jsx';
import ReactHotkeys from 'react-hot-keys';
import DisplayNotificationPushMessages from '../notifications/pushnotifications/DisplayNotificationPushMessages';
import DisplayNotifications from '../notifications/notificationtable/DisplayNotifications';
import DisplayTradePlanTypes from '../tradeplans/displayTradePlanTypes/DisplayTradePlanTypes';
import DisplayTradePlanWatchLists from '../tradeplans/watchlist/displayTradePlanWatchlists/DisplayTradePlanWatchlist';
import { makeStyles } from '@material-ui/core/styles';
import './layout.css';
import DisplayOrdersPending from '../notifications/orderpendingdisplay/DisplayOrdersPending';
import { OrdersTable } from '../tables/ordersTable/OrdersTable';
import { PositionsTable } from '../tables/positionsTable/PositionsTable';
import style from './LayoutByTp.module.css';
import TradePlanViewsContainer from '../tradeplans/TradePlanViewsContainer/TradePlanViewsContainer';
import { ActivityLogsTable } from '../tables/activityLogsTable/ActivityLogsTable';
import { NavBar } from '../navbar/NavBar';
import { ChartTradingButton } from "../../atomic/buttons/chartTradingButton/ChartTradingButton"
import { TradingModuleWrapper } from '../newTradingInterface/tradingModule/TradingModuleWrapper';
import WrapExistingPositionDrawer from '../../forms/tradeplans/wrapExistingPosition/WrapExistingPositionDrawer';

const useStyles = makeStyles({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  flexSection: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  flexColScroll: {
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
  },
  drawer: {
    //.scrollbar-hidden::-webkit-scrollbar: "",
    width: '33%',
    //position: "relative"
  },
});

export default function LayoutByTp({ userPreferences }) {
  const classes = useStyles();

  const [showWatchlist, setShowWatchlist] = useState(true);
  const [showTpViews, setShowTpViews] = useState(false);
  const [watchlistWidth, setWatchlistWidth] = useState(4);
  const [tpViewsWidth, setTpViewsWidth] = useState(4);
  const totalWidth = 12;
  const toUseWatchlistWidth = showWatchlist ? watchlistWidth : 0;
  const toUseTpWidth = showTpViews ? tpViewsWidth : false;
  const tpDisplay = showTpViews ? 'flex' : 'none';
  const tablesWidth = totalWidth - toUseWatchlistWidth - toUseTpWidth;
  const [tpOpen, setTpOpen] = useState(true);
  const [qtOpen, setQtOpen] = useState(false);
  const [showChartTrading, setShowChartTrading] = useState(false);
  const [showWrapDrawer, setShowWrapDrawer] = useState(false);
  const focusRef = useRef(null);
  //console.log(userPreferences);
  const savedConfigFocusRef = useRef(null);
  const quickTradeShortCut = 'alt+n';
  const openFormsShortCut = 'alt+a';

  const shortcutKeyActions = {
    [quickTradeShortCut]: {
      action: () => {
        setQtOpen(!qtOpen);
        setTpOpen(false);
        if (!showTpViews) {
          setShowTpViews(true);
        }
        focusRef.current.focus();
      },
    },
    [openFormsShortCut]: {
      action: () => {
        //if (!showTpViews) { //ie will be show tp views

        //}
        if (!showTpViews) {
          //ie we are turning to true
          if (qtOpen) {
            setQtOpen(false);
          }
          if (!tpOpen) {
            setTpOpen(true);
          }
        }
        setShowTpViews(!showTpViews);

        if (savedConfigFocusRef.current !== null) {
          savedConfigFocusRef.current.focus();
        }
      },
    },
  };
  const onKeyDown = (keyName, e, handle) => {
    shortcutKeyActions[keyName].action();
  };

  const [clearForm, setClearForm] = useState(false);
  const [refreshedForm, setRefreshedForm] = useState(false);

  return (
    <div className={style.outerContainer}>
      <ReactHotkeys
        keyName={quickTradeShortCut + ',' + openFormsShortCut}
        onKeyDown={onKeyDown}
      >
        <NavBar
          userPreferences={userPreferences}
          showTpViews={showTpViews}
          setShowTpViews={setShowTpViews}
          setShowChartTrading={setShowChartTrading}
          showWrapDrawer={showWrapDrawer}
          setShowWrapDrawer={setShowWrapDrawer}
        />
        <div className={style.body}>
          <div className={style.leftSection}>
            <PositionsTable />
            <OrdersTable />
            <ActivityLogsTable />
          </div>
          <div className={style.mainSection}>
            {showChartTrading ? <TradingModuleWrapper/> : null}
            <TradePlanViewsContainer />
            <DisplayTradePlanWatchLists userPreferences={userPreferences} />
          </div>
        </div>
        <DisplayOrdersPending />
        {clearForm ? (
          <RefreshForm
            refreshedForm={refreshedForm}
            setRefreshedForm={setRefreshedForm}
            setClearForm={setClearForm}
          />
        ) : (
          <DisplayTradePlanTypes
            showTpViews={showTpViews}
            userPreferences={userPreferences}
            setShowTpView={setShowTpViews}
            setQtOpen={setQtOpen}
            qtOpen={qtOpen}
            tpOpen={tpOpen}
            setTpOpen={setTpOpen}
            focusRef={focusRef}
            savedConfigFocusRef={savedConfigFocusRef}
            clearForm={clearForm}
            setClearForm={setClearForm}
            refreshedForm={refreshedForm}
            setRefreshedForm={setRefreshedForm}
          />
        )}
        <WrapExistingPositionDrawer
          open={showWrapDrawer}
          onClose={() => setShowWrapDrawer(false)}
          focusRef={savedConfigFocusRef}
        />
      </ReactHotkeys>
    </div>
  );
}

function RefreshForm({ refreshedForm, setRefreshedForm, setClearForm }) {
  if (refreshedForm) {
    console.log('set refresh form to false');
    setRefreshedForm(false);
    setClearForm(false);
  }
  return <></>;
}
/*
function WatchlistContainer() {
  return <DisplayAllSymbols />;
}*/
